var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPTypePayLatter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.586,
    height: 18.461,
    viewBox: "0 0 25.586 18.461",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_44448",
    "data-name": "Path 44448",
    d: "M125.137,104.56l-.19-1.09h0a2.209,2.209,0,0,0-2.56-1.789l-11.794,2.083h0a4.861,4.861,0,1,0-5.385,6.21v6.587a2.212,2.212,0,0,0,2.209,2.206H124.45a2.212,2.212,0,0,0,2.215-2.206v-9.9a2.2,2.2,0,0,0-1.527-2.1Zm.089,8.578H123.84a1.116,1.116,0,0,1-.825-.334,1.065,1.065,0,0,1-.314-.783,1.116,1.116,0,0,1,1.151-1.03h1.375ZM122.638,103.1a.771.771,0,0,1,.892.624l.115.731h-8.675ZM102.5,105.17a3.429,3.429,0,1,1,1.006,2.424A3.426,3.426,0,0,1,102.5,105.17Zm21.948,12.159H107.418a.771.771,0,0,1-.771-.768v-6.587a4.867,4.867,0,0,0,4.085-4.087h13.753a.768.768,0,0,1,.742.774v2.891h-1.418a2.5,2.5,0,0,0-1.818,4.266,2.563,2.563,0,0,0,1.806.762h1.438v1.982a.774.774,0,0,1-.785.768Zm-20.328-11.44a.719.719,0,1,1,0-1.438h1.087v-1.389a.719.719,0,0,1,1.438,0v2.108a.719.719,0,0,1-.719.719Z",
    transform: "translate(-101.078 -100.306)",
    fill: "#300787"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPTypePayLatter);
export default __webpack_public_path__ + "static/media/p_type_pay_latter.2f71769d8a9f0b375b9fe823df10350d.svg";
export { ForwardRef as ReactComponent };